export default "__VITE_ASSET__BhqBzhyT__"